interface SuggestionChipsProps {
  chips: string[];
  onPick(label: string): void;
  disabled?: boolean;
}

/**
 * Renders the agent-offered shortcut chips as tappable pills. Picking a chip
 * sends its label as a conversation turn. Chips are always optional — free
 * text remains the primary input — so they disable while a turn is in flight.
 */
export function SuggestionChips({ chips, onPick, disabled }: SuggestionChipsProps): JSX.Element | null {
  if (chips.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {chips.map((chip, i) => (
        <button
          key={`${chip}-${i}`}
          type="button"
          disabled={disabled}
          onClick={() => onPick(chip)}
          className="rounded-full border border-sage-300 bg-paper-50 px-3 py-1.5 font-body text-sm text-sage-700 transition-colors hover:bg-sage-300 hover:text-ink-900 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {chip}
        </button>
      ))}
    </div>
  );
}
